import { COACH } from "@/lib/coach";

export function CoachAvatar({ size = 40, ring = true, className = "" }) {
  return (
    <span className={`relative inline-block shrink-0 rounded-full overflow-hidden ${className}`}
      style={{ width: size, height: size, boxShadow: ring ? "0 0 0 2px #CCFF00, 0 0 22px rgba(204,255,0,0.45)" : undefined }}>
      <img src={COACH.photo} alt={COACH.name} className="w-full h-full object-cover scale-125" />
    </span>
  );
}
